import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountMenuState } from "./accountMenu.state";
import { AccountMenuCustomer, AccountMenuSection, HeaderAccountMenuData } from "./accountMenu.types";
import { getAccountMenu, getHeaderAccountMenu } from "./accountMenu.thunk";

const initialState: AccountMenuState = {
  data: null,
  status: "idle",
  error: null,
  customer: null,
  headerMenuData: null,
  headerMenuStatus: "idle",
  headerMenuError: null,
};

export const accountMenuSlice = createSlice({
  name: "accountMenu",
  initialState,
  reducers: {
    resetAccountMenu: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.customer = null;
      state.headerMenuData = null;
      state.headerMenuStatus = "idle";
      state.headerMenuError = null;
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getAccountMenu.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getAccountMenu.fulfilled,
        (state, action: PayloadAction<{ menus: AccountMenuSection[]; customer: AccountMenuCustomer }>) => {
          state.status = "success";
          state.data = action.payload.menus;
          state.customer = action.payload.customer;
        },
      )
      .addCase(
        getAccountMenu.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Menu yuklenemedi.";
        },
      )

      .addCase(getHeaderAccountMenu.pending, (state) => {
        state.headerMenuStatus = "loading";
        state.headerMenuError = null;
      })
      .addCase(
        getHeaderAccountMenu.fulfilled,
        (state, action: PayloadAction<HeaderAccountMenuData>) => {
          state.headerMenuStatus = "success";
          state.headerMenuData = action.payload;
        },
      )
      .addCase(
        getHeaderAccountMenu.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.headerMenuStatus = "error";
          state.headerMenuError = action.payload ?? "Header menu yuklenemedi.";
        },
      );
  },
});

export const { resetAccountMenu } = accountMenuSlice.actions;
export default accountMenuSlice.reducer;
